import React, { FC } from 'react';
import moment from 'moment';
import { Select, Icon } from '@firesoon/antd';

import { YearPickerProps } from '../interface';
import './index.less';

const { Option } = Select;
const YearPicker: FC<YearPickerProps> = (props) => {
  const {
    formatter = 'YYYY',
    value,
    placeholder = '请选择年份',
    suffix = '年',
    className = '',
    onChange,
    style = {},
    startYear = 2010,
    disabledDate,
    ...rest
  } = props;
  const years = [...Array(moment().year() - (startYear ?? 2010) + 1)].map((_, index) => ({
    value: moment().subtract(index, 'year'),
  }));

  const option = {
    // defaultValue: moment(defaultValue).format(formatter),
    placeholder,
    style: {
      width: 120,
      ...style,
    },
    ...rest,
  } as any;

  if (value) {
    option.value = value.format(formatter);
  }

  return (
    <Select
      suffixIcon={<Icon type="calendar" />}
      onChange={(value: any) => onChange?.(moment(value))}
      className={`fs-yearPicker ${className}`}
      dropdownClassName="fs-yearPicker-dropdown"
      // onPopupScroll={this.handleScroll}
      {...option}
    >
      {years.map((v) => (
        <Option
          key={v.value.format(formatter)}
          value={v.value.format(formatter)}
          title={`${v.value.format(formatter)}${suffix}`}
          disabled={disabledDate?.(v.value)}
        >
          {v.value.format(formatter)}
          {suffix}
        </Option>
      ))}
    </Select>
  );
};
export default YearPicker;
